@if (showTwoFactor) {
    <ins-two-factor [credentials]="credentials" (codeSuccess)="onOtpSuccess()" (sessionTimeout)="onSessionTimeout()" />
} @else {
    @if (showLoginTitle) {
        <h1 class="h2">Inloggen</h1>
    }
    <ins-login [loading]="loading$ | async" [errors]="errors" (login)="onLogin($event)" />
}
